import { formatTextToUseNewLineBeforeNumbers } from '../functions';
import { CHAT_ROLES } from '../constants';
import { sendMessage } from './api';

export const handleSendMessage = async ({
  prompt,
  addMessages,
  userWixId,
  condition,
  extractedInfo,
}) => {
  if (prompt) {
    addMessages([{
      role: CHAT_ROLES.ME,
      content: formatTextToUseNewLineBeforeNumbers(prompt),
    }]);

    const response = await sendMessage(prompt, userWixId, condition, extractedInfo);

    try {
      addMessages([{
        role: CHAT_ROLES.TINA,
        content: formatTextToUseNewLineBeforeNumbers(response.msg),
      }]);
    } catch (error) {
      addMessages([{
        role: CHAT_ROLES.TINA,
        content: formatTextToUseNewLineBeforeNumbers('Our System is busy. <br> please again resubmit our question'),
      }]);
    }
  }
};

export const countNonNullValues = (obj) => {
  let count = 0;
  for (const key in obj) {
    // Skip the specified keys
    if (
      key === 'profile_id'
      || key === 'temp_id'
      || key === 'user_wix_id'
      || key === 'user_type'
      || key === 'is_new'
      || key === 'qstack'
    ) {
      // eslint-disable-next-line no-continue
      continue;
    }

    // Check if the value is not null
    if (obj[key] !== null && obj[key] !== undefined && (typeof obj[key] !== 'object' || obj[key].length > 0)) {
      count += 1;
    }
  }
  return count;
};

export const extractNonNullValuesInfo = (obj) => {
  const nonNullKeyValuePairs = {}; // Use an object to store key-value pairs directly

  for (const key in obj) {
    if (obj[key] !== null && obj[key] !== undefined) {
      if (
        Array.isArray(obj[key])
        && obj[key].length > 0
        && key !== 'profile_id'
        && key !== 'temp_id'
        && key !== 'user_wix_id'
        && key !== 'user_type'
        && key !== 'is_new'
        && key !== 'qstack'
      ) {
        nonNullKeyValuePairs[key] = obj[key];
      } else if (!Array.isArray(obj[key])) {
        nonNullKeyValuePairs[key] = obj[key];
      }
    }
  }
  return nonNullKeyValuePairs;
};
